module.exports = __webpack_public_path__ + "img/sri_lanka.a89bc01e.svg";